import type { Deal } from '@/api/gen'
import { DealCard } from '@/components/deal-card'

export type DealsListProps = {
  deals: readonly Deal[]
  withSignUp?: boolean
}

export const DealsList = ({ deals, withSignUp }: DealsListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {deals.map((deal) => (
        <DealCard
          key={deal.deal_id}
          {...deal}
          withSignUp={withSignUp}
        />
      ))}
    </div>
  )
}
